import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';

// import SitePhotos from './SitePhotos';
// import SatisticInfo from './SatisticInfo';
// import WeatherInfoTable from './WeatherInfoTable';

// import Typography from '@material-ui/core/Typography';
// import * as strings from '../../helpers/strings';
import INVERTERINFO from './inverterInfo';
import ENERGYINFO from './energyMeterInfo';

const styles = {
  paperGauge1: { display: "flex", justifyContent: "center", paddingTop: 10, paddingBottom: 10, overflow: "hidden"},
  chartPaper: {  background: "linear-gradient(0deg, #343A40, 0.8%, #F8F8F8 0%)", minHeight: "100%",
  '@media screen and (max-width: 960px)': {
    minHeight: "auto"
  },},
  rowGrid: { marginBottom: 4 },
}

const RealtimeGraphs = ({ classes }) => (
  <div id="rt-graphs">

    <Grid container spacing={8} >
      <Grid item md={12} sm={12} xs={12}>
        <Grid container spacing={8} classes={{ container: classes.rowGrid }}>
          <Grid item md={6} sm={12} xs={12}>
            {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblEnergyMeterChart}>{strings.lblEnergyMeterChart}</Typography> */}
            <Paper className={classes.chartPaper}>
              <ENERGYINFO />
            </Paper>
          </Grid>
          <Grid item md={6} sm={12} xs={12}>
            {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblInverterChart}>{strings.lblInverterChart}</Typography> */}
            <Paper className={classes.chartPaper}>
              <INVERTERINFO />
            </Paper>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </div >
);

export default withStyles(styles)(RealtimeGraphs);